import { App as VueApp, inject } from 'vue'

export function getVueApp (): VueApp {
  const vueApp = inject<VueApp>('vue-service:vue-app')

  if (!vueApp) {
    throw new Error('could not inject the vueApp.')
  }

  return vueApp
}
